module.exports = __webpack_public_path__ + "static/media/setting.5e62164c.png";